/* Cellara FX – liczniki, oś czasu, wejścia sekcji, wideo na klik. Bez zależności. */
(function () {
  var d = document, root = d.documentElement;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  if (!design && !reduce && hasIO) root.classList.add('cx-ready');

  /* ---------- liczniki ---------- */
  function parse(raw) {
    var m = String(raw).trim().match(/^([^\d]*)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!m) return null;
    var dec = (m[2].split(/[.,]/)[1] || '').length;
    return { pre: m[1], num: parseFloat(m[2].replace(',', '.')), suf: m[3], dec: dec, sep: m[2].indexOf(',') > -1 ? ',' : '.' };
  }
  function fmt(p, v) { return p.pre + v.toFixed(p.dec).replace('.', p.sep) + p.suf; }
  function runCount(el) {
    var p = el._cx; if (!p) return;
    if (el._raf) cancelAnimationFrame(el._raf);
    var t0 = null, dur = 1800;
    function step(ts) {
      if (!t0) t0 = ts;
      var k = Math.min((ts - t0) / dur, 1), e = 1 - Math.pow(1 - k, 3);
      el.textContent = fmt(p, p.num * e);
      if (k < 1) el._raf = requestAnimationFrame(step); else el.textContent = el.getAttribute('data-cx-count');
    }
    el._raf = requestAnimationFrame(step);
  }

  /* ---------- obserwator wejść ---------- */
  var io = hasIO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var t = e.target;
      t.classList.add('is-in');
      if (t.hasAttribute('data-cx-count')) runCount(t);
      io.unobserve(t);
    });
  }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' }) : null;

  /* ---------- oś czasu ---------- */
  var lines = [], ticking = false;
  function updateLines() {
    ticking = false;
    var vh = window.innerHeight;
    lines.forEach(function (L) {
      var r = L.el.getBoundingClientRect();
      if (r.bottom < -50 || r.top > vh + 50) return;
      var start = vh * 0.62;
      var p = Math.max(0, Math.min(1, (start - r.top) / Math.max(1, r.height)));
      L.fill.style.transform = 'scaleY(' + p.toFixed(4) + ')';
      var reach = r.top + p * r.height;
      L.steps.forEach(function (s) {
        var dot = s.querySelector('[data-cx-dot]') || s;
        var top = dot.getBoundingClientRect().top + 8;
        s.classList.toggle('is-on', top <= reach + 1);
      });
    });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(updateLines); } }

  /* ---------- wideo: start tylko po kliknięciu, zawsze bez dźwięku ---------- */
  function initVideo(card) {
    if (card._cx) return; card._cx = 1;
    var v = card.querySelector('video'); if (!v) return;
    v.muted = true; v.defaultMuted = true; v.autoplay = false; v.loop = false;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.removeAttribute('autoplay');
    v.removeAttribute('controls');
    try { v.pause(); } catch (e) {}
    card.addEventListener('click', function () {
      if (v.paused) {
        d.querySelectorAll('[data-cx-video].is-playing video').forEach(function (o) { if (o !== v) o.pause(); });
        v.muted = true;
        var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
      } else v.pause();
    });
    v.addEventListener('play', function () { card.classList.add('is-playing'); });
    v.addEventListener('pause', function () { card.classList.remove('is-playing'); });
    v.addEventListener('ended', function () { card.classList.remove('is-playing'); v.currentTime = 0; });
    v.addEventListener('volumechange', function () { if (!v.muted) v.muted = true; });
  }

  function init(scope) {
    scope = scope || d;
    scope.querySelectorAll('[data-cx-video]').forEach(initVideo);

    scope.querySelectorAll('[data-cx-count]').forEach(function (el) {
      if (el._cxInit) return; el._cxInit = 1;
      el._cx = parse(el.getAttribute('data-cx-count'));
      if (!el._cx) return;
      if (design || reduce || !io) { el.textContent = el.getAttribute('data-cx-count'); return; }
      el.textContent = fmt(el._cx, 0);
      io.observe(el);
      var card = el.closest('[data-cx-count-host]') || el;
      if (window.matchMedia('(hover: hover)').matches) card.addEventListener('mouseenter', function () { runCount(el); });
    });

    scope.querySelectorAll('[data-cx-reveal]').forEach(function (el, i) {
      if (el._cxInit) return; el._cxInit = 1;
      if (design || reduce || !io) { el.classList.add('is-in'); return; }
      io.observe(el);
    });

    scope.querySelectorAll('[data-cx-timeline]').forEach(function (el) {
      if (el._cxInit) return; el._cxInit = 1;
      var fill = el.querySelector('[data-cx-fill]'); if (!fill) return;
      lines.push({ el: el, fill: fill, steps: [].slice.call(el.querySelectorAll('[data-cx-step]')) });
    });
    if (lines.length) updateLines();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  d.addEventListener('shopify:section:load', function (e) { lines = lines.filter(function (L) { return d.contains(L.el); }); init(e.target); });
})();
